import { render } from "./ModsView.vue?vue&type=template&id=6782a0d0&scoped=true&ts=true"
import script from "./ModsView.vue?vue&type=script&lang=ts"
export * from "./ModsView.vue?vue&type=script&lang=ts"

import "./ModsView.vue?vue&type=style&index=0&id=6782a0d0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6782a0d0"]])

export default __exports__